import { z } from 'zod'

export const eventSchema = z
    .object({
        name: z.string().min(1, 'Povinné pole').max(128, 'Maximálně 128 znaků'),
        startAt: z.string().nullable(),
        endAt: z.string().nullable()
    })
    .refine(
        v => {
            if (!v.startAt || !v.endAt) return true
            return new Date(v.endAt).getTime() >= new Date(v.startAt).getTime()
        },
        { message: 'Konec musí být po začátku', path: ['endAt'] }
    )

export type EventFormValues = z.infer<typeof eventSchema>
